module.exports = __webpack_public_path__ + "assets/logo_diia_white.87e2507b.svg";